import { render, staticRenderFns } from "./RiskmanagementHome.vue?vue&type=template&id=1cb3adef"
import script from "./RiskmanagementHome.vue?vue&type=script&lang=js"
export * from "./RiskmanagementHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports